import React, { Fragment, useContext, useMemo } from 'react';

import TettraEditor from '../../tettra-editor/components/TettraEditor';
import { pageToEditorState } from '../../tettra-editor/utilities/contentToEditorState';

import { PageContext } from '../../context/PageContext';

const CONFIG = {
    editorIdentifier: 'PageShow',
    readOnly: true,
    spellCheck: false,
    debug: false,
};

export default (props) => {
    const { page } = useContext(PageContext);
    const editorState = pageToEditorState(page);

    return useMemo(() => (
        <Fragment>
            {!editorState && <div className="page-middle-width"><span className="gray loading">Loading page</span></div>}
            {editorState && <TettraEditor editorState={editorState} config={CONFIG} /> }
        </Fragment>
    ), [editorState]);
};
